import { motion } from 'framer-motion'
import React from 'react'
import { FaVolumeOff, FaVolumeUp } from 'react-icons/fa'

interface ExamplesProps {
  topic: {
    examples: string[]
    examplesImages: string[]
  }
  isSpeaking: boolean
  speakExplanation: any
}

const Examples: React.FC<ExamplesProps> = ({ topic, isSpeaking, speakExplanation }) => {
  return (
    <div className='card shadow-lg rounded-lg p-4 mb-4'>
      {/* Header Section */}
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <h3 className='text-info font-weight-bold mb-3' style={{ fontSize: '2.2rem' }}>
          उदाहरण
        </h3>
        <button
          className='btn bg-transparent border-0 ms-3 d-flex align-items-center justify-content-center'
          onClick={() => speakExplanation(topic?.examples || [])}
          style={{
            fontSize: '1.5rem',
            cursor: 'pointer',
            transition: 'transform 0.2s ease, color 0.2s ease'
          }}
          onMouseDown={(e) => e.preventDefault()} // Prevent button flickering
        >
          {isSpeaking ? (
            <FaVolumeUp className='text-dark' style={{ transform: 'scale(1.2)' }} />
          ) : (
            <FaVolumeOff className='text-secondary' style={{ transform: 'scale(1.2)' }} />
          )}
        </button>
      </div>

      {/* Examples List - Display in rows of three */}
      {topic?.examplesImages && topic.examplesImages.length > 0 ? (
        <div className='d-flex justify-content-center flex-wrap mt-4'>
          {topic.examplesImages.map((example: any, index: number) => (
            <motion.img
              key={index}
              src={example.image}
              alt={`Example ${index + 1}`}
              className='img-fluid m-3 shadow-lg rounded'
              style={{ maxWidth: '400px', height: 'auto' }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            />
          ))}
        </div>
      ) : (
        <p className='text-danger' style={{ fontSize: '1.6rem' }}>
          कोई उदाहरण उपलब्ध नहीं है।
        </p>
      )}
    </div>
  )
}

export default Examples
